import { Checkbox } from "@/components/ui/checkbox";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { memo, useCallback } from "react";
import { useProjectStoreFormStore } from "../hooks/useProjectStoreFormStore";
import { selectPeriod } from "../stores/projectStoreFormStore";

interface PeriodCheckboxProps {
  storeId: string;
  periodId: string;
  isBusy: boolean;
}

const PeriodCheckbox = memo(
  ({ storeId, periodId, isBusy }: PeriodCheckboxProps) => {
    const { can_update } = useModulePermissions();
    const checked = useProjectStoreFormStore(
      useCallback(
        (s) => selectPeriod(s, storeId, periodId),
        [storeId, periodId],
      ),
    );
    const togglePeriod = useProjectStoreFormStore((s) => s.togglePeriod);

    const onCheckedChange = useCallback(() => {
      togglePeriod(storeId, periodId);
    }, [togglePeriod, storeId, periodId]);

    return (
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={isBusy || !can_update}
      />
    );
  },
);

PeriodCheckbox.displayName = "PeriodCheckbox";

export default PeriodCheckbox;
